module.exports = __webpack_public_path__ + "static/media/task_words.cb0e9608.svg";